<template>
  <div
    v-loading.fullscreen.lock="fullLoading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <el-dialog
      :title="$l('风险提示书')"
      width="800px"
      append-to-body
      :visible.sync="riskTipDialogVisible"
      @close="riskTipDialogVisible = false"
      class="risk-tip-dialog"
    >
      <div class="risk-tip">
        <h1 class="center bold">使用电梯智慧功能的风险提示书</h1>
        <p>尊敬的用户：</p>
        <p class="em">感谢选用日立电梯及使用电梯智慧功能！</p>
        <p class="em">
          为保障电梯的安全运行，同时确保电梯相关智慧功能的使用符合法律法规，特向贵用户提示使用电梯智慧功能期间，可能存在的安全、法律风险及应注意的事项。敬请贵用户在接收电梯智慧功能的管理账号及开通相应权限前，详细阅读本提示书内容：
        </p>
        <h3 class="bold">
          一、因对电梯智慧功能的管理账号、权限管理不善而带来的风险
        </h3>
        <p class="em">
          风险：贵用户接收电梯智慧功能管理账号且开通相应管理员权限后，若未采取有效措施保护账号安全及规范权限的使用，存在安全、法律风险（包括但不限于）：
        </p>
        <ul class="em">
          <li>
            1、账号遭非授权人员盗取、盗用，存在贵用户系统信息数据泄露的风险；
          </li>
          <li>
            2、管理人员或其他授权人员违反贵用户指示，擅自使用相关智慧功能，造成贵用户或第三方人身、财产损害，贵用户可能因此承担法律责任的风险等。
          </li>
        </ul>
        <p class="em">建议：</p>
        <ul class="em">
          <li>
            1、贵司应建立并完善账号、权限管理制度，对系统及账号采取安全保密措施；
          </li>
          <li>2、对账号管理人员（授权人员）进行岗前及操作培训；</li>
          <li>3、建立健全监督管理体系，加强事后监督；</li>
        </ul>
        <h3 class="bold">
          二、因未取得相应资质及许可或对通过智能播报系统、实时播放功能所发布信息审查不当而带来的风险
        </h3>
        <p class="em">风险：</p>
        <ul class="em">
          <li>
            1、根据发布信息的类型，贵用户若在信息发布前未取得相关资质、许可的，存在被相关部门要求下架、删除及处以其他行政处罚的风险；
          </li>
          <li>
            2、贵用户作为信息的直接发布者和管理者，应履行谨慎审查义务。若贵用户在信息发布前未对信息内容进行实质审查和监督的，根据信息内容的不同，存在违反《中华人民共和国民法典》《中华人民共和国个人信息保护法》《中华人民共和国广告法》《中华人民共和国反不正当竞争法》等法律禁止性规定或侵害第三方合法权益的风险。
          </li>
        </ul>
        <p class="em">建议：</p>
        <ul class="em">
          <li>
            1、根据法律、行政法规及其他规范性文件要求，结合信息类型、内容，依法取得相应资质和许可后另行发布；
          </li>
          <li>
            2、完善信息发布审查机制，履行审核义务，对违反法律规定的内容及时予以修改、调整；针对已发布的内容进行删除操作等。
          </li>
        </ul>
        <h3 class="bold">
          三、因违反信息数据保护相关法律规定或缺乏对通过电梯智慧功能所收集的个人信息、数据有效保护和管理而带来的风险
        </h3>
        <p class="em">风险：</p>
        <ul class="em">
          <li>
            1、贵用户作为个人信息及数据处理者，若未采取有效措施对收集、存储的个人信息、数据进行保护的，存在因数据信息泄露导致贵用户被追责的法律风险；
          </li>
          <li>
            2、若贵用户在未向第三人充分告知的前提下，违规处理个人信息、违反必要原则强制要求第三人提供有关个人信息或者未经允许从第三人电子设备直接收集个人信息，存在违反我国关于个人信息保护法律规定及被第三人追究的法律风险；
          </li>
        </ul>
        <p class="em">建议：</p>
        <ul class="em">
          <li>
            1、贵用户应按照《中华人民共和国个人信息保护法》《中华人民共和国数据安全法》《信息安全技术
            个人信息安全规范》（GB/T
            35273-2020）《人脸识别技术应用安全管理办法》等国家法律规范及相关标准要求采取一切必要措施，制定有效的安全事件应急预案，防止未经授权的访问、篡改，保障用户个人信息和其他数据安全。
          </li>
          <li>
            2、贵用户在处理第三方用户个人信息、数据前应当以显著方式、清晰易懂的语言真实、准确、完整地向其告知包括但不限于个人信息的处理目的、处理方式、处理的个人信息种类、保存期限等内容并取得第三方用户的同意；涉及敏感个人信息处理（如个人身份信息、个人生物识别信息等）的，应取得第三方用户个人的单独同意。
          </li>
          <li>
            3、贵用户或贵用户授权人员即使为实现公共安全保障、困人救援协助、设备异常排查及事故追溯之目的，使用“电梯实时监控”功能时，若需处理第三方个人信息，仍应当向第三方履行告知义务，并取得个人同意。
          </li>
        </ul>
        <h3 class="bold">
          四、因违反安全保障义务或违反操作指引使用可视化监控和电梯调控功能而带来的风险
        </h3>
        <p class="em">风险：</p>
        <ul class="em">
          <li>
            1、贵用户可以通过使用云监视、云管家、可视化监控平台的相关功能，远程监控电梯实时运行状态，接收预警故障及其他电梯故障的推送；同时可以通过电脑端下达控制指令，实现对电梯进行远程控制调度，但若贵用户未能履行安全保障义务，在控制、调度期间错误下达指令，存在承担乘梯人员的人身、财产损害赔偿责任的风险。
          </li>
        </ul>
        <p class="em">建议：</p>
        <ul class="em">
          <li>
            1、贵用户应开展权限管理人员安全操作培训。相关人员完成安全培训后在操作电梯控制或调度权限前，暂缓开通梯控权限，避免安全事故发生。
          </li>
        </ul>
        <p class="em">
          贵用户在接收智慧功能管理权限后，如因未能全面妥当地履行相关的管理职责或法律义务，将自行承担相应法律风险和责任，前述的建议仅供参考，不构成我司对相应责任承担的承诺。
        </p>
        <p class="em">
          感谢贵用户耐心阅读，请按照系统要求点击确认，确认知悉本提示所有内容。
        </p>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button round @click="cancel()">{{ $l("取消") }} </el-button>
        <el-button round type="primary" @click="agree()"
          >{{ $l("同意") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "riskTip",
  props: {
    isSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fullLoading: false,
      riskTipDialogVisible: false,
    };
  },
  methods: {
    show() {
      if (this.isSave) {
        this.fullLoading = true;
        this.$http
          .get(this.$apiConfig.is_risk_confirm_url)
          .then((response) => {
            this.fullLoading = false;
            let result = response.data;
            if (result.code == 0) {
              if (result.data) {
                this.$emit("agree");
              } else {
                this.riskTipDialogVisible = true;
              }
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      } else {
        this.riskTipDialogVisible = true;
      }
    },
    agree() {
      this.riskTipDialogVisible = false;
      if (this.isSave) {
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.save_risk_confirm_log_url)
          .then((response) => {
            this.fullLoading = false;
            let result = response.data;
            if (result.code == 0) {
              this.$emit("agree");
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      } else {
        this.$emit("agree");
      }
    },
    cancel() {
      this.riskTipDialogVisible = false;
      this.$emit("cancel");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.risk-tip {
  border: 1px solid #ccc;
  height: 390px;
  overflow-y: auto;
  padding: 10px;
  h1 {
    font-size: 24px;
  }
  .bold {
    font-weight: bold;
  }
  .em {
    text-indent: 2em;
  }
  .dline {
    text-decoration: underline;
  }
  .center {
    text-align: center;
  }
}
</style>
